// src/components/HomePage.js
import React, { useState } from 'react';
import MapSpinner from '../components/MapSpinner'; // Import the new MapSpinner
import '../styles/HomePage.css';

const map_url = "https://maps.google.com/maps?q=etsisi&t=m&z=10&output=embed&iwloc=near";

const HomePage = () => {
  const [isMapLoading, setIsMapLoading] = useState(true);

  return (
    <div className="homepage">
      <div className="row full-width">
        <h1>About us</h1>
        <p>
          SeCLab is a specialized research group at the Technical University of Madrid dedicated to tackling advanced cybersecurity challenges across software, hardware, and cryptography.
          Our primary focus areas include malware attribution, secure serverless computing, digital forensics, and random number generation.
          In our research projects, we seek to address security needs in software integrity, hardware resilience, and cryptographic safeguards. 
        </p>
      </div>
      <div className="row half-half">
        <div className="column">
          <h1 className="find-us">Where to find us</h1>
          <p className="info">
            <h3>Address:</h3>
            <ul>
              <li>Departamento de Sistemas Informáticos</li>
              <li>Escuela Técnica Superior de Ingeniería de Sistemas Informáticos</li>
              <li>Universidad Politécnica de Madrid</li>
              <li>Campus Sur - Calle Alan Turing s/n</li>
              <li>(Ctra. de Valencia, Km. 7) – 28031 Madrid</li>
            </ul>
            <br />
            <b>Email:</b> <a href="mailto:gi.seclab@upm.es">gi.seclab@upm.es</a>
          </p>
        </div>
        <div className="column" style={{ position: 'relative' }}>
          {isMapLoading && <MapSpinner />} {/* Show spinner only while map loads */}
          <iframe title="Map"
            src={map_url}
            onLoad={() => setIsMapLoading(false)} // Hide spinner once map loads
            allowFullScreen=""
            loading="lazy"
            style={{ borderRadius: '8px', padding: '10px' }}
          ></iframe>
        </div>
      </div>

    </div>
  );
};

export default HomePage;
